import { DollarSign, MapPin, Phone, Mail, Clock, Shield, Users, CheckCircle, Star, Award, CreditCard, Zap, Building, FileText, Calculator, TrendingUp, BookOpen, HelpCircle } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const Index = () => {
  const loanTypes = [
    {
      title: "Payday Loans",
      description: "Quick cash advances to bridge the gap until your next payday. Same-day approval with no credit check required.",
      icon: <DollarSign className="w-8 h-8 text-green-600" />,
      color: "border-green-200 bg-green-50",
      features: ["Same-day approval", "No credit check", "Up to $1,000", "Online application"]
    },
    {
      title: "Personal Loans",
      description: "Flexible personal loans for various financial needs. Competitive rates and transparent terms.",
      icon: <CreditCard className="w-8 h-8 text-blue-600" />,
      color: "border-blue-200 bg-blue-50",
      features: ["Flexible terms", "Competitive rates", "Up to $5,000", "Quick approval"]
    },
    {
      title: "Installment Loans",
      description: "Structured repayment plans that fit your budget. Predictable monthly payments over time.",
      icon: <FileText className="w-8 h-8 text-purple-600" />,
      color: "border-purple-200 bg-purple-50",
      features: ["Fixed payments", "Extended terms", "Budget-friendly", "Transparent fees"]
    },
    {
      title: "Cash Advances",
      description: "Immediate cash when you need it most. Fast processing and quick fund transfer.",
      icon: <Zap className="w-8 h-8 text-orange-600" />,
      color: "border-orange-200 bg-orange-50",
      features: ["Instant approval", "Fast transfer", "Emergency funds", "24/7 access"]
    }
  ];

  const locations = [
    { city: "New Orleans", state: "LA", anchor: "payday loans New Orleans", url: "https://quickloanpro.com/new-orleans-la/" },
    { city: "Alexandria", state: "LA", anchor: "payday loans Alexandria", url: "https://quickloanpro.com/alexandria-la/" },
    { city: "Lafayette", state: "LA", anchor: "payday loans Lafayette", url: "https://quickloanpro.com/lafayette-la/" },
    { city: "Lake Charles", state: "LA", anchor: "payday loans Lake Charles", url: "https://quickloanpro.com/lake-charles-la/" },
    { city: "Laplace", state: "LA", anchor: "payday loans Laplace", url: "https://quickloanpro.com/payday-loans-laplace-la/" },
    { city: "Slidell", state: "LA", anchor: "payday loans Slidell", url: "https://quickloanpro.com/payday-loans-slidell-la/" },
    { city: "Baker", state: "LA", anchor: "payday loans Baker", url: "https://quickloanpro.com/payday-loans-baker-la/" },
    { city: "Belle Chasse", state: "LA", anchor: "payday loans Belle Chasse", url: "https://quickloanpro.com/payday-loans-belle-chasse/" },
    { city: "Benton", state: "LA", anchor: "payday loans Benton", url: "https://quickloanpro.com/payday-loans-benton-la/" },
    { city: "Blanchard", state: "LA", anchor: "payday loans Blanchard", url: "https://quickloanpro.com/payday-loans-blanchard-la/" },
    { city: "Central", state: "LA", anchor: "payday loans Central", url: "https://quickloanpro.com/payday-loans-central-la/" },
    { city: "Chalmette", state: "LA", anchor: "payday loans Chalmette", url: "https://quickloanpro.com/payday-loan-solutions-chalmette-la/" },
    { city: "Crowley", state: "LA", anchor: "payday loans Crowley", url: "https://quickloanpro.com/payday-loans-crowley-la/" },
    { city: "Denham Springs", state: "LA", anchor: "payday loans Denham Springs", url: "https://quickloanpro.com/payday-loans-denham-springs-la/" },
    { city: "DeQuincy", state: "LA", anchor: "payday loans DeQuincy", url: "https://quickloanpro.com/payday-loans-dequincy-la/" },
    { city: "Eunice", state: "LA", anchor: "payday loans Eunice", url: "https://quickloanpro.com/payday-loans-eunice-la/" },
    { city: "Harvey", state: "LA", anchor: "payday loans Harvey", url: "https://quickloanpro.com/payday-loans-harvey-la/" },
    { city: "Iowa", state: "LA", anchor: "payday loans Iowa", url: "https://quickloanpro.com/payday-loans-iowa-la/" },
    { city: "Minden", state: "LA", anchor: "payday loans Minden", url: "https://quickloanpro.com/payday-loans-minden-la/" },
    { city: "Opelousas", state: "LA", anchor: "payday loans Opelousas", url: "https://quickloanpro.com/payday-loans-opelousas-la/" },
    { city: "Plain Dealing", state: "LA", anchor: "payday loans Plain Dealing", url: "https://quickloanpro.com/payday-loans-plain-dealing-la/" },
    { city: "Prairieville", state: "LA", anchor: "payday loans Prairieville", url: "https://quickloanpro.com/payday-loans-prairieville-la/" },
    { city: "Rayne", state: "LA", anchor: "payday loans Rayne", url: "https://quickloanpro.com/payday-loans-rayne-la/" },
    { city: "Sulphur", state: "LA", anchor: "payday loans Sulphur", url: "https://quickloanpro.com/payday-loans-sulphur-la/" },
    { city: "Sunset", state: "LA", anchor: "payday loans Sunset", url: "https://quickloanpro.com/payday-loans-sunset-la/" },
    { city: "Vinton", state: "LA", anchor: "payday loans Vinton", url: "https://quickloanpro.com/payday-loans-vinton-la/" },
    { city: "Vivian", state: "LA", anchor: "payday loans Vivian", url: "https://quickloanpro.com/payday-loans-vivian-la/" },
    { city: "Westlake", state: "LA", anchor: "payday loans Westlake", url: "https://quickloanpro.com/payday-loans-westlake-la/" },
    { city: "Westwego", state: "LA", anchor: "payday loans Westwego", url: "https://quickloanpro.com/payday-loans-westwego-la/" },
    { city: "Zachary", state: "LA", anchor: "payday loans Zachary", url: "https://quickloanpro.com/payday-loans-zachary-la/" }
  ];

  const features = [
    {
      icon: <Zap className="w-6 h-6 text-green-600" />,
      title: "Same-Day Approval",
      description: "Get approved within minutes and receive funds the same day"
    },
    {
      icon: <Shield className="w-6 h-6 text-blue-600" />,
      title: "No Credit Check",
      description: "Bad credit? No problem. We focus on your ability to repay"
    },
    {
      icon: <Users className="w-6 h-6 text-purple-600" />,
      title: "Trusted Service",
      description: "4.3/5 stars on Trustpilot with excellent customer reviews"
    },
    {
      icon: <Building className="w-6 h-6 text-orange-600" />,
      title: "Licensed Lender",
      description: "Fully licensed and regulated financial service provider"
    }
  ];

  const benefits = [
    "Quick online application process",
    "Same-day fund transfer available",
    "No hidden fees or charges",
    "Transparent terms and conditions",
    "24/7 online access",
    "Secure and confidential",
    "Bad credit accepted",
    "Responsible lending practices"
  ];

  const trustpilotReviews = [
    {
      rating: 5,
      text: "I had my doubts about online payday loans, but QuickLoanPro changed my mind. The application process was simple, and I received immediate approval.",
      author: "Verified Customer"
    },
    {
      rating: 5,
      text: "QuickLoanPro impressed me a lot. The application was so smooth. Funds transfer was super fast. Recommended.",
      author: "Verified Customer"
    },
    {
      rating: 5,
      text: "When I needed money urgently, QuickLoanPro was a lifesaver. The loan application was easy, and I received the funds faster than expected.",
      author: "Verified Customer"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-100">
      {/* Header */}
      <header className="bg-white shadow-lg">
        <div className="container mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-4">
              <img 
                src="https://quickloanpro.com/storage/2023/11/Payday-Loans-Louisiana-Logo.png" 
                alt="QuickLoanPro Logo"
                className="w-16 h-16 object-contain"
              />
              <div>
                <h1 className="text-2xl font-bold text-gray-900">QuickLoanPro</h1>
                <p className="text-gray-600">Your Trusted Financial Partner</p>
              </div>
            </Link>
            <div className="hidden md:flex items-center gap-4">
              <Phone className="w-5 h-5 text-green-600" />
              <span className="text-gray-700">+1 (504) 438-1753</span>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-green-600 text-white py-3">
        <div className="container mx-auto px-4">
          <div className="flex items-center gap-6">
            <Link to="/" className="font-semibold">Home</Link>
            <Link to="/payday-loans" className="hover:text-green-200 transition-colors">Payday Loans</Link>
            <Link to="/personal-loans" className="hover:text-green-200 transition-colors">Personal Loans</Link>
            <Link to="/installment-loans" className="hover:text-green-200 transition-colors">Installment Loans</Link>
            <Link to="/cash-advances" className="hover:text-green-200 transition-colors">Cash Advances</Link>
            <Link to="/title-loans" className="hover:text-green-200 transition-colors">Title Loans</Link>
            <Link to="/how-it-works" className="hover:text-green-200 transition-colors">How It Works</Link>
            <Link to="/faq" className="hover:text-green-200 transition-colors">FAQ</Link>
            <Link to="/about" className="hover:text-green-200 transition-colors">About Us</Link>
            <Link to="/contact" className="hover:text-green-200 transition-colors">Contact</Link>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="py-16 bg-gradient-to-r from-green-600 to-blue-700 text-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Fast Cash When You Need It Most
              </h2>
              <p className="text-xl md:text-2xl mb-8 opacity-90">
                QuickLoanPro offers reliable payday loans and personal loans across Louisiana. Same-day approval, no credit check required.
              </p>
              <div className="flex flex-wrap gap-4 mb-8">
                <Badge className="bg-white/20 text-white text-lg px-4 py-2">
                  <Zap className="w-5 h-5 mr-2" />
                  Same-Day Approval
                </Badge>
                <Badge className="bg-white/20 text-white text-lg px-4 py-2">
                  <Shield className="w-5 h-5 mr-2" />
                  No Credit Check
                </Badge>
                <Badge className="bg-white/20 text-white text-lg px-4 py-2">
                  <Star className="w-5 h-5 mr-2" />
                  4.3/5 Trustpilot
                </Badge>
              </div>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button 
                  size="lg" 
                  className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-xl px-8 py-4"
                  onClick={() => window.open('https://quickloanpro.com/', '_blank')}
                >
                  Apply Now
                </Button>
                <Button 
                  size="lg" 
                  variant="outline" 
                  className="border-white text-white hover:bg-white hover:text-green-600 font-bold text-xl px-8 py-4"
                >
                  Learn More
                </Button>
              </div>
            </div>
            <div className="hidden md:block">
              <img 
                src="/images/payday_loans_1.png" 
                alt="QuickLoanPro - Fast Payday Loans and Personal Loans"
                className="rounded-lg shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Loan Types Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            Our Loan Services
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {loanTypes.map((loan, index) => (
              <Card key={index} className={`hover:shadow-xl transition-shadow duration-300 border-2 ${loan.color}`}>
                <CardHeader>
                  <div className="flex items-center gap-3 mb-3">
                    {loan.icon}
                    <CardTitle className="text-lg">{loan.title}</CardTitle>
                  </div>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-700 mb-4 text-sm">{loan.description}</p>
                  <ul className="space-y-2">
                    {loan.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center gap-2 text-sm">
                        <CheckCircle className="w-4 h-4 text-green-600" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            Serving Louisiana Communities
          </h2>
          <div className="grid md:grid-cols-3 lg:grid-cols-4 gap-6">
            {locations.map((location, index) => (
              <Card key={index} className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <MapPin className="w-8 h-8 text-green-600 mx-auto mb-3" />
                  <h3 className="text-lg font-semibold mb-2">{location.city}, {location.state}</h3>
                  <Button 
                    variant="outline" 
                    size="sm"
                    className="text-green-600 border-green-600 hover:bg-green-50"
                    onClick={() => window.open(location.url, '_blank')}
                  >
                    {location.anchor}
                  </Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-gradient-to-r from-gray-50 to-green-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold mb-6 text-gray-900">
                Why Choose QuickLoanPro?
              </h2>
              <div className="space-y-4 text-gray-700">
                <p>
                  <strong>QuickLoanPro</strong> is your trusted partner in times of financial need. We understand the challenges of navigating financial hurdles, which is why we provide same-day and online payday loans to individuals and families across the United States.
                </p>
                <p>
                  Our team is dedicated to revolutionizing how you think about financial assistance, offering a seamless and reliable experience that you can count on when you need it most.
                </p>
                <p>
                  We specialize in providing quick financial solutions with a focus on <strong>transparency and customer education</strong>. Our services are designed to meet the diverse financial needs of our clients, wherever they are.
                </p>
                <p className="font-semibold text-green-800">
                  At QuickLoanPro, we are committed to fair lending practices, ensuring that every transaction is straightforward and that our clients are fully informed.
                </p>
              </div>
            </div>
            <div>
              <img 
                src="/images/payday_loans_2.jpeg" 
                alt="QuickLoanPro Financial Services"
                className="rounded-lg shadow-lg"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Expert Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://quickloanpro.com/storage/2025/05/Emily-K.-Lawson-4.png" 
                alt="Emily K. Lawson - Certified Credit Advisor"
                className="rounded-lg shadow-lg"
              />
            </div>
            <div>
              <h2 className="text-3xl font-bold mb-6 text-gray-900">
                Meet Our Financial Expert
              </h2>
              <div className="space-y-4 text-gray-700">
                <h3 className="text-2xl font-semibold text-green-800">Emily K. Lawson</h3>
                <p className="text-lg font-medium text-blue-600">Certified Credit Advisor & Personal Finance Writer</p>
                <p>
                  Emily K. Lawson is a certified credit advisor and personal finance writer with over <strong>10 years of experience</strong> in the short-term lending industry. She is passionate about helping Americans navigate financial emergencies with practical advice and clear explanations.
                </p>
                <p>
                  Based in <strong>New Orleans, Louisiana</strong>, Emily combines her industry insights with a people-first approach to educate readers on responsible borrowing, credit management, and financial wellness.
                </p>
                <p className="font-semibold text-green-800">
                  At QuickLoanPro.com, she shares up-to-date content designed to empower smart money choices and reduce debt stress.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            What Makes Us Different
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <Card key={index} className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <div className="flex justify-center mb-4">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 bg-gradient-to-r from-green-50 to-blue-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            QuickLoanPro Benefits
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {benefits.map((benefit, index) => (
              <Card key={index} className="text-center hover:shadow-lg transition-shadow">
                <CardContent className="p-6">
                  <CheckCircle className="w-8 h-8 text-green-600 mx-auto mb-3" />
                  <p className="font-semibold text-gray-800 text-sm">{benefit}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Trustpilot Reviews */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold mb-4 text-gray-900">
              What Our Customers Say
            </h2>
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <span className="text-xl font-bold">4.3/5</span>
              <span className="text-gray-600">on Trustpilot</span>
            </div>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {trustpilotReviews.map((review, index) => (
              <Card key={index} className="border-l-4 border-l-green-500">
                <CardContent className="p-6">
                  <div className="flex mb-4">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
                    ))}
                  </div>
                  <p className="text-gray-700 mb-4 italic">"{review.text}"</p>
                  <p className="font-semibold">- {review.author}</p>
                  <div className="mt-2">
                    <Badge variant="outline" className="text-xs">
                      Verified Trustpilot Review
                    </Badge>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-gradient-to-r from-gray-50 to-green-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">
            Contact Information
          </h2>
          <div className="grid md:grid-cols-2 gap-12">
            <Card className="p-8">
              <CardHeader>
                <CardTitle className="text-2xl mb-4 flex items-center gap-2">
                  <MapPin className="w-6 h-6 text-green-600" />
                  Our Location
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 text-green-600 mt-1" />
                    <div>
                      <p className="font-semibold">4901 Bloomfield St</p>
                      <p className="text-gray-600">New Orleans, LA 70121</p>
                      <p className="text-gray-600">United States</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="p-8">
              <CardHeader>
                <CardTitle className="text-2xl mb-4 flex items-center gap-2">
                  <Phone className="w-6 h-6 text-blue-600" />
                  Get In Touch
                </CardTitle>
              </CardHeader>
              <CardContent>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <Phone className="w-5 h-5 text-blue-600" />
                    <div>
                      <p className="font-semibold">+1 (504) 438-1753</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="w-5 h-5 text-green-600" />
                    <div>
                      <p className="font-semibold">info@quickloanpro.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Clock className="w-5 h-5 text-purple-600 mt-1" />
                    <div>
                      <p className="font-semibold">Office Hours:</p>
                      <p>Monday - Friday: 8:00 AM - 6:00 PM</p>
                      <p>Saturday: 9:00 AM - 6:00 PM</p>
                      <p>Sunday: 9:00 AM - 6:00 PM</p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-green-600 to-blue-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Apply for your payday loan or personal loan today. Quick approval, same-day funding available.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg" 
              className="bg-yellow-500 hover:bg-yellow-600 text-black font-bold text-xl px-8 py-4"
              onClick={() => window.open('https://quickloanpro.com/', '_blank')}
            >
              Apply for Loan Now
            </Button>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-white text-white hover:bg-white hover:text-green-600 font-bold text-xl px-8 py-4"
            >
              Check Eligibility
            </Button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">QuickLoanPro</h3>
              <p className="text-gray-400 mb-4">
                Your trusted partner for payday loans, personal loans, and financial assistance across Louisiana and beyond.
              </p>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  <span>+1 (504) 438-1753</span>
                </div>
                <div className="flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  <span>info@quickloanpro.com</span>
                </div>
                <div className="flex items-center gap-2">
                  <MapPin className="w-4 h-4" />
                  <span>New Orleans, LA</span>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Loan Services</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>Payday Loans</li>
                <li>Personal Loans</li>
                <li>Installment Loans</li>
                <li>Cash Advances</li>
                <li>Title Loans</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Louisiana Cities</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>New Orleans</li>
                <li>Baton Rouge</li>
                <li>Shreveport</li>
                <li>Lafayette</li>
                <li>Lake Charles</li>
                <li>Kenner</li>
              </ul>
            </div>
            
            <div>
              <h4 className="font-semibold mb-4">Company</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>About Us</li>
                <li>How It Works</li>
                <li>Privacy Policy</li>
                <li>Terms of Service</li>
                <li>Responsible Lending</li>
                <li>Contact Us</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2025 QuickLoanPro. All rights reserved.</p>
            <p className="mt-2">Licensed financial service provider committed to responsible lending practices.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Index;